(function () {
    'use strict';

    angular.module("imApp").factory("deviationsService", ['$ihttp', function ($ihttp) {
        let service = {
            listDeviations: function (parms) {
                return $ihttp.post({
                    method: 318,
                    parameters: parms || {}
                });
            },
            getCustactNo: function (parms) {
                return $ihttp.post({
                    method: 320,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
